import { Resource as o, API as a } from "@coveo/platform-client";
const s = class s extends o {
  /**
   * Sets the project ids associated to the provided resource.
   *
   * @param {string} resourceId
   * @param {ProjectResourceType} resourceType
   * @param {string[]} associatedProjectIds
   * @returns {Promise<void>}
   */
  updateAssociations(i, r, e) {
    return this.api.post(
      this.buildPath(
        `${s.baseUrl}/resources/${i}/projectids?resourceType=${r}`
      ),
      e
    );
  }
};
s.baseUrl = `/rest/organizations/${a.orgPlaceholder}/projects`;
let t = s;
export {
  t as ProjectInternalResource
};
//# sourceMappingURL=ProjectInternalResource.js.map
